<template>
    <div>
        <template v-if="$parent.routeSection === 0">
            <MaterialSetup :formValue="formValue"></MaterialSetup>
        </template>
        <template v-else-if="$parent.routeSection === 1">
            <StudyDesign :formValue="formValue"></StudyDesign>
        </template>
        <template v-else-if="$parent.routeSection === 2">
            <SitesAndDepots :formValue="formValue"></SitesAndDepots>
        </template>
        <template v-else-if="$parent.routeSection === 3">
            <SupplyChain :formValue="formValue"></SupplyChain>
        </template>
        <template v-else-if="$parent.routeSection === 4">
            <Packaging :formValue="formValue"></Packaging>
        </template>
        <template v-else-if="$parent.routeSection === 5">
            <Shippers :formValue="formValue"></Shippers>
        </template>
    </div>
</template>

<script>
    import MaterialSetup from "./Study/MaterialSetup.vue"
    import StudyDesign from "./Study/StudyDesign.vue"
    import Packaging from "./Study/Packaging.vue"
    import SupplyChain from "./Study/SupplyChain.vue"
    import SitesAndDepots from "./Study/SitesAndDepots.vue"
    import Shippers from "./Study/Shippers.vue"

    export default {
        name: "StudyEditor",
        components: {
            MaterialSetup,
            Packaging,
            SupplyChain,
            Shippers,
            SitesAndDepots,
            StudyDesign
        },
        props: {
            formValue: {
                type: Object,
                required: true
            }
        },
        data: () => ({
            sideMenu: [{
                name: "Material setup",
                sub: [
                    "Dosage Forms",
                    "Primary Packaging",
                    "Secondary Packaging",
                    "Dispensing Units",
                    "Ancillary Items",
					"Review Materials"
                ]
            },{
                name: "Study design",
                sub: [
                    "General",
                    "Enrolment Targets",
                    "Enrolment Categorization",
                    "Enrolment Suspend Period",
                    "Treatment Groups",
                    "Dosage Regimens",
                    "Dispensing Schedules"
                ]
            },{
                name: "Sites and depots",
                sub: [
                    "Sites",
                    "Site Ancillaries",
                    "Depots",
                    "Supply Plans"
                ]
            },{
                name: "Supply chain",
                sub: [
                    "Setup Supply Chains",
                    "Risk"
                ]
            },{
                name: "Packaging",
                sub: [
                    "Planned Batches",
                    "Batch Templates"
                ]
            },{
                name: "Shippers",
                sub: [
                    "Packing Constraints",
                    "Shipper Types",
                    "Review Shipper Setup"
                ]
            }],
            headlines: [{
                headline: "Material Setup",
                subHeadline: "Setup and manage material types and DUN packaging"
            },{
                headline: "Study Design",
                subHeadline: "Enter core study protocol parameters"
            },{
                headline: "Sites and Depots",
                subHeadline: "Setup and manage sites and depots"
            },{
                headline: "Supply Chain",
                subHeadline: "Setup shippers and supply routes"
            },{
                headline: "Packaging",
                subHeadline: "Setup and manage planned and future DUN Lat/batches"
            },{
                headline: "Shippers",
                subHeadline: "Setup and manage shippers and freight cost"
            }]
        }),
        mounted(){
            this.$emit("setSideMenu", this.sideMenu);
            this.$emit("setHeadlines", this.headlines);
        }
    }
</script>
